import { makeStyles } from "@material-ui/core";

const useStyles = makeStyles((theme) => ({
    title: {
        marginBottom: theme.spacing(2)
    },
    addButton: {
        marginBottom: theme.spacing(1)
    },
    exportButton: {
        marginLeft: theme.spacing(2),
        marginBottom: theme.spacing(1)
    },
    csvExportBtn: {
        color: '#ffffff',
        textDecoration: 'none'
    },
    userName: {
        fontSize: 20,
        fontWeight: 'bold'
    },
    perviewButton: {
        marginBottom: '5px',
    },
    Buttonstyle:{
        marginBottom: '5px'
    },
    ExportButtonstyle:{
          marginLeft: '10px',
    marginBottom: '5px'
    },
    PerviewButtonstyle:{
        marginBottom: '5px'
    }

}));
export default useStyles;
